import './custom.css';
import './login/style.css';

import DocumentTitle from 'bz-core-controls/controls/document-title';
import Fallback from 'bz-core-controls/controls/lazy/controls/fallback';
import createReactClass from 'create-react-class';
import $ from 'jquery';
import React from 'react';
import z from 'z';
import ShellLogo from './shell/logo';
import ShellMarketing from './shell/marketing';
import ShellPrivacy from './shell/privacy';
import ShellTerms from './shell/terms';

const ShellFullscreen = React.lazy(() => import('./shell/fullscreen'));

const Shell = createReactClass({
  displayName: 'Shell',

  getInitialState() {
    let fullScreenPrompt;
    if (navigator.userAgent.match(/android/i)) {
      fullScreenPrompt = true;
    }
    return {
      fullScreenPrompt,
      loaded: false
    };
  },

  componentDidMount() {
    this.setState({ loaded: true });
    return $('#tm2-app').css({ height: '100%' });
  },

  componentWillUnmount() {
    this.setState({ loaded: false });
    return $('#tm2-app').css({ height: 'auto' });
  },

  goFullScreen() {
    const doc = window.document;
    const docEl = doc.documentElement;
    const fs =
      docEl.requestFullScreen || docEl.webkitRequestFullScreen || docEl.mozRequestFullScreen;
    fs.call(docEl);
    return this.setState({ fullScreenPrompt: false });
  },

  dismissPrompt() {
    return this.setState({ fullScreenPrompt: false });
  },

  render() {
    const TM3 = z.word('TM3');
    return (
      <DocumentTitle title={`${TM3} > Login`}>
        <div className="login-wrapper">
          <React.Suspense fallback={<Fallback />}>
            {this.state.fullScreenPrompt && (
              <ShellFullscreen dismiss={this.dismissPrompt} fullscreen={this.goFullScreen} />
            )}
            <div className="login-container bg-white">
              <div className="login-content">
                <div className="grid justify-center">
                  <ShellLogo />
                </div>
                {this.props.children}
              </div>
              <div className="login-footer">
                <div className="clearfix">
                  <small>
                    <ShellTerms />
                    <ShellPrivacy />
                  </small>
                </div>
              </div>
            </div>
            <ShellMarketing />
          </React.Suspense>
        </div>
      </DocumentTitle>
    );
  }
});

export default Shell;
